import React, { useEffect, useState } from 'react';
export function StickyHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleCheckout = () => {
    window.location.href = 'https://productosdigitalesnuevos.myshopify.com/checkouts/cn/hWN9n9b8dLQ0zWcM4lh6BQg6/es-ar?_r=AQAB3sxDrVfYMB8G5oC3KtOEXxVl3WNVcpKRPbVzMknQ1i0&cart_link_id=QdC5wTSR&preview_theme_id=146146721979';
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0d0906]/90 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5 opacity-0 pointer-events-none'}`} data-id="element-167">
      <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-168">
        <div className="text-xl font-bold text-white tracking-tight" data-id="element-169">
          Postres en <span className="text-[#d4a843]" data-id="element-170">Vaso</span>
        </div>
        <button onClick={handleCheckout} className="px-6 py-2 text-sm font-bold text-[#1a1008] bg-gradient-to-r from-[#d4a843] to-[#f0c14b] rounded-full transition-transform hover:scale-105" data-id="element-171">
          Comprar Ahora
        </button>
      </div>
    </header>;
}